import React from 'react';

import { css } from '@emotion/css';
import { Text, TextArea } from '@opendoor/bricks/core';
import { Value } from 'classnames';

const styles = {
  text_label_bottom_padding: css`
    padding-bottom: 7px;
  `,
  field_bottom_padding: css`
    padding-bottom: 20px;
  `,
  text_area_border_radius: css`
    border-radius: 25px;
  `,
  text_area_field_width: css`
    width: 100%;
  `,
  text_area_placeholder: css`
    &::placeholder {
      color: gray;
      opacity: 1;
    }
  `,
};

type onChangeHandler = (
  event: React.ChangeEvent<HTMLTextAreaElement>,
  name: string,
  value?: Value,
) => void;

interface ParnTextAreaFieldProps {
  title: string;
  id: string;
  ariaLabel: string;
  name: string;
  placeholder?: string;
  content?: string;
  onChangeHandler: onChangeHandler;
  analyticsName: string;
}

// storybook-check-ignore
export const ParnTextAreaField: React.FC<ParnTextAreaFieldProps> = ({
  title,
  id,
  ariaLabel,
  name,
  placeholder,
  content,
  onChangeHandler,
  analyticsName,
}) => {
  return (
    <>
      <Text size="s1" fontWeight="semibold" className={styles.text_label_bottom_padding}>
        {title}
      </Text>
      <div className={`${styles.field_bottom_padding} ${styles.text_area_field_width}`}>
        <TextArea
          id={id}
          aria-label={ariaLabel}
          name={name}
          placeholder={placeholder}
          content={content}
          onChange={onChangeHandler}
          analyticsName={analyticsName}
          resizable={true}
          unboundedWidth={true}
          style={{
            height: '80px',
            width: styles.text_area_field_width,
            border: '2px solid #DEDEDE',
          }}
          className={styles.text_area_placeholder}
        />
      </div>
    </>
  );
};

export default ParnTextAreaField;
